import { render } from "./RoosterComponent.vue?vue&type=template&id=0ce19b44&scoped=true"
import script from "./RoosterComponent.vue?vue&type=script&lang=js"
export * from "./RoosterComponent.vue?vue&type=script&lang=js"

import "./RoosterComponent.vue?vue&type=style&index=0&id=0ce19b44&scoped=true&lang=css"
import "./RoosterComponent.vue?vue&type=style&index=1&id=0ce19b44&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce19b44"]])

export default __exports__